<app-loader *ngIf="loader"></app-loader>
<mat-drawer-container hasBackdrop="true">
  <mat-drawer #sideNav mode="over" position="end" class="doc-panel" [style.width]=" sidebar_width">
    <app-user-profile [data]="data" [sideNavRef]="sidebar_ref">
    </app-user-profile>
  </mat-drawer>
  <mat-drawer-content style="min-height: 90vh;"
    [ngStyle]="{'background':  this.portal_details && this.portal_details.portalBackgroundImage?  ('url(https://storage.googleapis.com/ezeone/icanrefer/'+this.portal_details.portalBackgroundImage + ')'):'' ,'background-size':'contain' }">
    <app-navbar [sidebarref]="sidebar_ref">
    </app-navbar>


    <router-outlet ></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
<app-footer></app-footer>
<!-- <app-gamification></app-gamification> -->
<div id="pageMessages">
</div>